/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Refund_BtnInputs */

const vi_customer_refund_btn = /** @type {(inputs: Customer_Refund_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tiền`)
};

/**

* @param {Customer_Refund_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_refund_btn = /** @type {((inputs?: Customer_Refund_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Refund_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_refund_btn(inputs)
});